import "./TestCard.css";

import { Box, Button, Card, Chip, Typography } from "@mui/material";

import React from "react";
import { dateFormater } from "../../hooks/dateFormater";

const TestCard = (props) => {
	const title = props.title;
	const section = props.section;
	const date = props.date;
	const progress = props.progress;
	const hadleViewScore = props?.hadleViewScore;
	const id = props?.id;
	return (
		// <Card
		// 	sx={{
		// 		display: "flex",
		// 		flexDirection: { xs: "column", sm: "row" }, // Stack on mobile, row on larger screens
		// 		alignItems: { xs: "start", sm: "center" },
		// 		justifyContent: "space-between",
		// 		p: 2,
		// 		borderRadius: "12px",
		// 		boxShadow: "0px 4px 36.1px 2px rgba(0, 0, 0, 0.25)",
		// 		width: "100%",
		// 		maxWidth: "600px", // Adjusts dynamically
		// 		m: "auto", // Centers the card
		// 	}}>
		// 	{/* Left Section - Title & Chip */}
		// 	<Box sx={{ flex: 1 }}>
		// 		<Typography variant='h6' sx={{ color: "#1F21E6", fontWeight: "bold" }}>
		// 			{title}
		// 		</Typography>
		// 		<Chip size='small' label={section} color='success' sx={{ mt: 1 }} />
		// 	</Box>

		// 	{/* Right Section - Date & Button */}
		// 	<Box sx={{ textAlign: { xs: "left", sm: "right" } }}>
		// 		<Typography variant='h6' sx={{ color: "#1F21E6", fontWeight: "bold" }}>
		// 			Date: {date}
		// 		</Typography>
		// 		<Button
		// 			variant='contained'
		// 			sx={{
		// 				mt: 1,
		// 				backgroundColor: "#1F21E6",
		// 				"&:hover": { backgroundColor: "#1519b8" },
		// 			}}>
		// 			View Score
		// 		</Button>
		// 	</Box>
		// </Card>
		<Card
			sx={{
				display: "flex",
				flexDirection: "column",
				paddingX: "1.5rem",
				paddingTop: "1.375rem",
				borderRadius: "12px",
				boxShadow: "0px 4px 36.1px 2px rgba(0, 0, 0, 0.25)",
				justifyContent: "space-between",
				gap: "1rem",
				// width: { sm: "15.625rem", md: "37.5rem" }, // 300px for mobile, 600px for tablet and up
				// width: "100%",
			}}>
			<Box sx={{ display: "flex", justifyContent: "space-between" }}>
				<Typography variant='h6' sx={{ color: "#1F21E6", fontWeight: "normal" }}>
					{title}
				</Typography>
				<Typography variant='h6' sx={{ color: "#1F21E6", fontWeight: "normal" }}>
					Date: {dateFormater(date)}
				</Typography>
			</Box>
			<Box sx={{ display: "flex", alignItems: "center" }}>
				<Chip size='small' label={section} color='success' sx={{ mt: 1 }} />
			</Box>
			<Box sx={{ display: "flex", justifyContent: "flex-end" }}>
				<Button
					onClick={() => {
						hadleViewScore(id);
					}}
					variant='contained'
					sx={{
						mt: 1,
						backgroundColor: "#1F21E6",
						"&:hover": { backgroundColor: "#1519b8" },
					}}>
					View Score
				</Button>
			</Box>
			<Box>
				<Box className='progress-bar'>
					<Box
						className={`progress-bar-fill ${
							progress >= 90 ? "green" : progress >= 60 ? "blue" : "red"
						}`}
						style={{ width: `${progress}%` }}></Box>
				</Box>
			</Box>
		</Card>
	);
};

export default TestCard;
